import { Box, Stack, Pagination } from '@mui/material';
import React from 'react';

interface PaginacionProps {
  elementos: any[];
  elementosPorPag: number;
  paginaActual: number;
  handleChange: (event: any, value: React.SetStateAction<number>) => void;
}

const Paginacion = ({ elementos, elementosPorPag, paginaActual, handleChange }: PaginacionProps) => {
  return (
    <Box mt={4}>
      <Stack spacing={2}>
        <Pagination
          count={Math.ceil(elementos.length / elementosPorPag)}
          page={paginaActual}
          onChange={handleChange}
          variant="outlined"
          sx={{ display: 'flex', justifyContent: 'center' }}
        />
      </Stack>
    </Box>
  );
};

export default Paginacion;
